<template>
  <modal :title="$t(title)" :visible.sync="isShowDialog" width="50%">
    <div class="contentDio" v-loading="detailLoading">
      <!-- 详细信息 -->
      <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" />
      <div class="detailMsg">
        <BaseList
          :baseMsg="baseMsg"
          :isMode.sync="isMode"
          ref="BaseList"
          @saveDecFn="saveDecFn"
        />
        <Upload :Upload="Upload" :isMode="isMode" ref="upload" />
        <!-- <changeIcon :isMode="isMode" @modeChange="modeChange" /> -->
      </div>
      <template v-if="tabsArray.length">
        <Tabs
          :tabs="tabsArray"
          :activeCom.sync="TabsActive"
          @handleTabs="handleTabs"
        />
        <keep-alive>
          <component
            :is="TabsActive"
            v-bind="$attrs"
            :calibrationInfo="calibrationInfo"
            :devType="5"
          />
        </keep-alive>
      </template>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false">
        {{ $t('buttonTitle.Close') }}
      </el-button>
      <el-button
        type="primary"
        @click="historyFn"
        v-if="sensorWay !== 'unknown'"
      >
        {{ $t('device.history_data') }}
      </el-button>
    </div>
  </modal>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue'
import EscalRule from '@/pages/equipment/publicCom/EscalRule.vue'
import NetParam from '@/pages/equipment/publicCom/NetParam.vue'
// import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue';
import Application from '@/pages/equipment/publicCom/Application.vue'
import Upload from '@/pages/equipment/publicCom/Upload.vue'
import resultHandle from '@/common/resultHandle'

import BaseList from './component/BaseList.vue'

import { updateGas } from '@/api/modules/sensor.js'
import bus from '@/utils/bus'
import { sensorHistory } from '@/utils/winDetail'
import { sensorHistoryQueryFormat } from '@/utils/simplify/query'
// import { getTabs } from '@/components/dialog/gasDetail/tabController'
import SoundLightAlarm from './tabs/SoundLightAlarm.vue'
import GpsLocate from '@/components/dialog/sensorDetail/component/tabs/GpsLocate.vue'

import Calibration from '@/pages/equipment/publicCom/Calibration.vue'

export default {
  props: {
    title: {},
    isShowDetail: {},
    detailLoading: {},
    baseMsg: {
      type: Array
    },
    detailObj: {},
    sensorWay: {
      default: 'bind'
    },
    // 全对象
    detailData: {},

    calibrationInfo: {}
  },
  watch: {
    detailObj (newVal) {
      this.isMode = false

      this.Upload = {
        imageUrl: { ...newVal }.pictureBase64,
        // 图片后缀
        imageSuffix: { ...newVal }.pictureSuffix
      }
      console.log('newVal.type========', newVal, newVal.type)
      // this.tabsArray = getTabs(newVal.type)
      // if (this.tabsArray.length) {
      //   this.TabsActive = this.tabsArray[0].name
      // }
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowDetail
      },
      set: function (val) {
        this.$emit('update:isShowDetail', val)
      }
    }
  },
  components: {
    Tabs,
    BaseList,
    Upload,
    // changeIcon,
    Application,
    EscalRule,
    NetParam,
    SoundLightAlarm,
    GpsLocate,
    Calibration
  },
  data () {
    return {
      detailArray: [],

      isEdit: true,
      // 详细信息
      detailTbs: [
        {
          name: 'Detail',
          label: 'public.detail_info'
        }
      ],
      Dactive: 'Detail',
      // 图片
      Upload: {},
      // 设备tabs
      tabsArray: [
        {
          name: 'Application',
          label: 'public.attribute'
        },
        {
          name: 'EscalRule',
          label: 'public.escalation_rules'
        }
      ],
      TabsActive: 'Application',
      // 模式切换
      isMode: false
    }
  },

  methods: {
    // modeChange() {
    //     this.isMode = !this.isMode;
    //     this.$refs['BaseList'].areaValue = this.baseMsg[this.baseMsg.length - 1]['content'];
    //     this.$refs['BaseList'].nickname = this.baseMsg[this.baseMsg.length - 2]['content'];
    // },
    saveDecFn (row) {
      const { imageSuffix, imageUrl } = this.$refs.upload.newUpload
      updateGas({
        id: this.detailObj.id,
        // nickname: row.nickname,
        description: row.areaValue,
        uploadFileBase64: imageUrl,
        uploadFileSuffix: imageSuffix,
        // 增加type
        type: this.detailObj.type
      }).then(async ({ state }) => {
        await resultHandle(state)
        this.isEdit = !this.isEdit
        this.isMode = !this.isMode
        // this.$emit('changdetail', this.detailObj);
        bus.$emit('gasParam', this.detailObj.id, this.detailObj.gas_code)
        this.isMode = !this.isMode
      })
    },
    isEditFn () {
      this.isEdit = !this.isEdit
      this.$children.areaValue = this.baseMsg[this.baseMsg.length - 1].content
      this.$children.nickname = this.baseMsg[this.baseMsg.length - 2].content
    },
    cancelFn () {
      this.isEdit = !this.isEdit
    },
    historyFn () {
      const params = sensorHistoryQueryFormat(this.detailObj)
      // 因为传感器写的历史数据的组件接口请求参数的值no:tag_id,气体么有tag_id，使用gas_code
      params.tagId = this.detailObj.gas_code
      // 因为传感器写的历史数据的组件接口请求参数的值devCatalog直接写的0,气体要格外增加一些参数修改
      params.devCatalog = 5
       if(this.detailObj.type ===6){
        params.probe = 'coz'
      }else{
        params.probe = 'gas'
      }
      // 有些字段命名不一样
      params.scopeName =  this.detailObj.scene_name
      params.carrierName =  this.detailObj.carrier_name
      params.carrierId =  this.detailObj.carrier_id
      params.carrierTypeId =  this.detailObj.carrier_type
      sensorHistory(params)
    },
    handleTabs (name) {
      this.TabsActive = name
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 900px;
}

.contentDio {
  max-height: 700px;
  box-sizing: border-box;
  overflow: auto;

  .detailMsg {
    display: flex;
  }

  .msgContent {
    li {
      line-height: 30px;
    }
  }

  .m15 {
    margin: 15px 0;
  }

  ::v-deep .el-textarea__inner {
    border-radius: 2px;
    // margin-left: 5px;
  }
}

</style>
